exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#OfferServices .flex-section .flex-section-header {\n  min-width: 20%; }\n\n#OfferServices .item-box {\n  min-height: 120px; }\n  #OfferServices .item-box .description {\n    font-size: .8em; }\n  #OfferServices .item-box .addon {\n    position: absolute;\n    bottom: 10px;\n    right: 16px;\n    font-size: 14px; }\n    #OfferServices .item-box .addon input[type=number] {\n      padding-right: 20px; }\n", ""]);

// exports
